import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
// [redux -- users]
import {
  usersAsValueAndLabelSelectors,
  usersIsLoadingSelector,
  currentUserSelector
} from '../../../modules/users/Selectors';
import {
  getUserAction,
  getUsersAction,
  get
} from '../../../modules/users/Actions';

// [redux -- artisan]
import {
  createArtisanAction,
  updateArtisanAction,
  getArtisanAction,
  UpdateArtisanLimitAction
} from '../../../modules/artisans/Actions';
import {
  artisansIsLoadingSelector,
  artisanByIdSelector
} from '../../../modules/artisans/Selectors';

// [redux -- artisan categories]
import { getArtisanCategoriesAction } from '../../../modules/artisanCategories/Actions';
import {
  artisanCategoriesAsLabelAndValueSelector,
  artisanCategoriesIsLoadingSelector
} from '../../../modules/artisanCategories/Selectors';

import {
  FormGroup,
  InputField,
  Upload,
  TextArea,
  Select,
  SearchableSelect,
  CheckBox,
  FormSectionTitle,
  Separator
} from '../../../components/form/';

import WorkingHours from '../../../components/form/WorkingHours';
import ArtisanBIOi18n from '../../../components/form/i18nForm/FormBIOi18n';
import Schema from '../artisans/artisansSchema';
import setWizardPage from '../../../helpers/setWizardPage';
import { globalFail } from '../../../modules/globalFail/Selector';
import { setRedirectFalse } from '../../../modules/globalFail/Action';
import { authCurrentDefaultTypeSelecetor } from '../../../modules/auth/Selectors';
import { updateAuthArtisanAction } from '../../../modules/auth/Actions';
import getLangData from '../../../utils/getLangData';

const companySizeOptions = [
  {
    label: '1-10',
    value: '1-10'
  },
  {
    label: '10-100',
    value: '10-100'
  },
  {
    label: '100-1000',
    value: '100-1000'
  },
  {
    label: 'More Than 1000',
    value: '1000+'
  }
];

const options = [
  {
    value: ['0'],
    label: 'Workshop'
  },
  {
    value: ['1'],
    label: 'Distributor'
  },
  {
    value: ['2'],
    label: 'Shop'
  }
];

const ArtisansForm = props => {
  // users
  const { mappedUsers, getUsers, usersIsLodaing, artisanData } = props;

  // artisans
  const {
    createArtisan,
    getArtisan,

    updateArtisan,
    artisan,
    artisanId,
    artisansIsLoading,
    page,
    setPage,
    currentUser,
    fail,
    edit,
    redirectFalse,
    getSingleUser,
    reload,
    userDefaultType,
    updateLimits,
    updateAuthArtisan,
    staging,
    authId
  } = props;

  // categories
  const { categories, getCategories, categoriesIsloading } = props;

  useEffect(() => {
    getCategories({ hasParent: true, size: 50 });
  }, []);
  useEffect(() => {
    // getUsers();
    if (artisanId) {
      getArtisan(artisanId);
      // console.log(artisan)
    }
  }, [getArtisan, artisanId]);
  useEffect(() => {
    if (!edit) {
      fail && setWizardPage(page, '3', setPage);
      redirectFalse();
    }
    if (reload) {
      fail && window.location.reload();
    }
  }, [fail]);

  // if (page.indexOf('3') === -1) return <div></div>;
  return (
    <Formik
      validationSchema={Schema(!artisanData ? true : false)}
      enableReinitialize
      initialValues={artisanData ? { ...artisanData } : Schema().cast()}
      onSubmit={values => {
        // let newPage = page;
        // let indexArtisan = newPage.indexOf('3');
        // if (indexArtisan > -1) {
        //   newPage.splice(indexArtisan, 1);
        // }
        // setPage([...newPage]);
        // console.log('submit', newPage, [...newPage]);
        // console.log('submitttt')
        const mappedCID = artisan ? values.categoryData : values.artisanCID;
        const artisanCID = mappedCID.map(cid =>
          typeof cid === 'object' ? cid._id : cid
        );

        // const userID =artisan ? values.userData._id :values.userID._id;
        const geolocation = [-2.777434, 53.7222317];
        const { _id } = currentUser;
        if (edit) {
          const data = {
            ...values,
            artisanCID,
            geolocation,
            userID: values._id
          };
          if (userDefaultType === '0' || userDefaultType === '1') {
            updateArtisan(values._id, data);
          } else {
            updateAuthArtisan({
              artisanID: values._id,
              ...values,
              geolocation
            });
          }
          // console.log(data);
          // console.log(values.categoryData);
        } else {
          if (staging) {
            createArtisan(
              { ...values, userID: authId, artisanCID, geolocation },
              false
            );
          } else {
            createArtisan(
              { ...values, userID: _id, artisanCID, geolocation },
              true
            );
          }
          // currentUser._id && getSingleUser(_id);
          // reload && window.location.reload()
        }
      }}
    >
      {({ handleSubmit, values, errors, setFieldValue }) => (
        <FormGroup
          isLoading={artisansIsLoading}
          heading={
            edit ? `${getLangData().fields.update} [${artisanData.businessName}]` : getLangData().fields.create_artisan
          }
          handleSubmit={handleSubmit}
          errors={errors}
        >
          <FormSectionTitle>
            {getLangData().tables.basic_info}

            {/* Basic Information : */}
          </FormSectionTitle>
          {/* {artisan ? (
            <>
              <InputField
                name='userData.firstName'
                label='First Name'
                disabled
              />
              <InputField name='userData.lastName' label='Last Name' disabled />{' '}
            </>
          ) : (
            <SearchableSelect
              isLoading={usersIsLodaing}
              options={mappedUsers}
              getItems={getUsers}
              name='userID'
              label='User'
              optionLabel={option =>
                `Name : ${option.firstName} ${option.lastName} - Email : ${option.email} - Phone : ${option.phone}`
              }
            />
          )} */}

          <SearchableSelect
            options={categories}
            getItems={getCategories}
            isLoading={categoriesIsloading}
            name={edit ? 'artisanCategoryData' : 'artisanCID'}
            label={getLangData().fields.artisan_category}
            isMulti={true}
          />

          <InputField name='businessName' label={getLangData().fields.busience_name} />
          <ArtisanBIOi18n name='businessNamei18n' description={getLangData().fields.busience_name} />

          <Select
            inArray={true}
            options={options}
            name='businessType'
            label={getLangData().fields.busience_type}
          />

          <Upload
            data={{ userID: currentUser._id }}
            name='logo'
            label={getLangData().fields.logo}
            S3Bucket='warshatna-artisans'
            // API="customer/customer-category-image-signedurl/"
            API='artisan/artisan-profile-logo-signedurl/'
          />

          <TextArea name='artisanBIO' label={getLangData().fields.artisan_bio} />
          <ArtisanBIOi18n name='artisanBIOi18n' description={getLangData().fields.artisan_bio} />
          <Separator />
          <FormSectionTitle>{getLangData().fields.company_store} </FormSectionTitle>
          <CheckBox
            name='onlineStore'
            label={getLangData().fields.store_online}
            subLabel='I have Online Store.'
          />
          <CheckBox
            name='offlineStore'
            label={getLangData().fields.store_offline}
            subLabel='I have Offline Store.'
          />
          <InputField name='yearEstablished' label={getLangData().fields.year_established} />
          <CheckBox
            name='regCompany'
            label={getLangData().fields.registered_company}
            subLabel='I have Registered Company.'
          />
          <Select
            options={companySizeOptions}
            name='companySize'
            label={getLangData().fields.company_size}
          />
          {
            // Bio
          }
          <Separator />
          <FormSectionTitle>{getLangData().fields.contact_person_details} </FormSectionTitle>
          <InputField name='contactPerson' label={getLangData().fields.contact_person} />
          <InputField name='contactPersonTitle' label={getLangData().fields.contact_person_title} />
          <InputField name='contactPersonPhone' label={getLangData().fields.contact_person_phone} />
          <InputField name='contactPersonEmail' label={getLangData().fields.contact_person_email} />
          <Separator />
          <FormSectionTitle>{getLangData().fields.social_online}</FormSectionTitle>
          <InputField name='website' label={getLangData().fields.website} />
          <InputField name='facebook' label={getLangData().fields.facebook} />
          <InputField name='instagram' label={getLangData().fields.instagram} />
          <InputField name='youtube' label={getLangData().fields.youtube} />
          <Separator />

          <FormSectionTitle>{getLangData().fields.working_hours} </FormSectionTitle>
          <WorkingHours name='workingHours'>
            <a
              onClick={() => {
                setFieldValue(
                  `workingHours.tuesdayF`,
                  values.workingHours.mondayF
                );
                setFieldValue(
                  `workingHours.wednesdayF`,
                  values.workingHours.mondayF
                );
                setFieldValue(
                  `workingHours.thursdayF`,
                  values.workingHours.mondayF
                );
                setFieldValue(
                  `workingHours.fridayF`,
                  values.workingHours.mondayF
                );
                setFieldValue(
                  `workingHours.saturdayF`,
                  values.workingHours.mondayF
                );
                setFieldValue(
                  `workingHours.sundayF`,
                  values.workingHours.mondayF
                );

                setFieldValue(
                  `workingHours.tuesdayT`,
                  values.workingHours.mondayT
                );
                setFieldValue(
                  `workingHours.wednesdayT`,
                  values.workingHours.mondayT
                );
                setFieldValue(
                  `workingHours.thursdayT`,
                  values.workingHours.mondayT
                );
                setFieldValue(
                  `workingHours.fridayT`,
                  values.workingHours.mondayT
                );
                setFieldValue(
                  `workingHours.saturdayT`,
                  values.workingHours.mondayT
                );
                setFieldValue(
                  `workingHours.sundayT`,
                  values.workingHours.mondayT
                );
              }}
            >
              {getLangData().fields.applay_monday}
            </a>
          </WorkingHours>
          {/*   
        <Switch name='workingHours.monday' subLabel={'Mon'} />

 */}
          <Separator />
          {userDefaultType === '0' && (
            <>
              <FormSectionTitle>Artisan Status :</FormSectionTitle>
              <CheckBox name='verified' label='Verified' />
              <CheckBox name='trusted' label='Trusted' />
              {/* <CheckBox name="moderated" label="Moderated" /> */}
              <Separator />

              {artisanData && (
                <>
                  <FormSectionTitle>Artisan Limit</FormSectionTitle>
                  <InputField name='subscriptionModel.artisanPostJobsLimit' />
                  <InputField name='subscriptionModel.artisanViewCVLimit' />
                  <div
                    className='btn btn-primary'
                    onClick={() => {
                      if (userDefaultType === '0') {
                        const data = {
                          artisanID: values._id,
                          artisanPostJobsLimit:
                            values.subscriptionModel.artisanPostJobsLimit,
                          artisanViewCVLimit:
                            values.subscriptionModel.artisanViewCVLimit
                        };
                        updateLimits(data);
                      }
                    }}
                  >
                    Update Limits
                  </div>
                </>
              )}
            </>
          )}
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const artisanId = '';
  // const artisanId = 'dumb testing';
  return {
    // users
    mappedUsers: usersAsValueAndLabelSelectors(state),
    usersIsLodaing: usersIsLoadingSelector(state),
    currentUser: currentUserSelector(state),
    fail: globalFail(state),
    //artisans
    artisanId,
    artisansIsLoading: artisansIsLoadingSelector(state),
    artisan: artisanByIdSelector(state, artisanId),
    // categories
    categories: artisanCategoriesAsLabelAndValueSelector(state),
    categoriesIsloading: artisanCategoriesIsLoadingSelector(state),
    userDefaultType: authCurrentDefaultTypeSelecetor(state)
  };
};

const mapDispatchToProps = {
  // users
  getSingleUser: getUserAction,
  getUsers: getUsersAction,
  redirectFalse: setRedirectFalse,
  // artisans
  createArtisan: createArtisanAction,
  updateArtisan: updateArtisanAction,
  getArtisan: getArtisanAction,
  // categories
  getCategories: getArtisanCategoriesAction,
  updateLimits: UpdateArtisanLimitAction,
  // Staging
  updateAuthArtisan: updateAuthArtisanAction
};
export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ArtisansForm)
);
